module.exports = __webpack_public_path__ + "static/media/orga-img-b.859c24ad.jpeg";